<template>
<div>
  <div class="content" style="width: auto">
    <div class="cont-list">
      <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
    </div>

    <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
      <div class="edit-card">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">请领基础信息</span>
        </div>
        <el-row>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="no" label="请领单号">
              <el-input disabled v-model="form.no"></el-input>
            </el-form-item>
            <span class="viewText" v-else> 请领单号:{{ form.no }}</span>
          </el-col>
          <!-- <el-col :span="6">
              <el-form-item label="申请时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="createdUserName" label="申请人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col> -->
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="ownerDeptName" label="所属科室">
              <el-input disabled v-model="form.ownerDeptName"></el-input>
            </el-form-item>
            <span class="viewText" v-else>所属科室: {{ form.ownerDeptName }}</span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="applyDeptName" label="请领科室">
              <el-select v-if="system_setting.IsUseWard" v-model="form.applyDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards" @change="applyDeptChange1">
                <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
              </el-select>
              <!--12  -->
              <el-select v-else v-model="form.applyDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptsBySessionDeptId" @change="applyDeptChange">
                <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name" :value="item.id"></el-option>
              </el-select>

            </el-form-item>
            <span class="viewText" v-else>请领科室: {{ form.applyDeptName }}</span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="oneLevelWarehouseName" label="目标库房">
              <el-select v-model="form.oneLevelWarehouseName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getWarehouseList" @change="oneLevelWarehouseChange">
                <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else> 目标库房:{{ form.oneLevelWarehouseName }}</span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="oneLevelWarehouseManagerId" label="目标库房库管员">
              <el-input disabled v-model="form.oneLevelWarehouseManagerName"></el-input>
            </el-form-item>
            <span class="viewText" v-else> 目标库房库管员:{{ form.oneLevelWarehouseManagerName }}</span>
          </el-col>
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="pressingState" label="紧急标识">
              <el-select v-model="form.pressingState" :disabled="!editMode" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else> 紧急标识:{{  OrderPressingOptions.find(item => item.id === form.pressingState)?.name  }}</span> 
          </el-col>
        </el-row>

        <el-row>
          <!-- <el-col :span="6">
              <el-form-item prop="warehouseName" label="申请仓库">
                <el-select v-model="form.warehouseName" placeholder="请选择" :disabled="!editMode" style="width:100%" filterable :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="warehouseManagerId" label="库管员">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
            </el-col> 
          </el-row>

          <el-row>-->
          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="category" label="类型">
              <el-select v-model="form.category" placeholder="请选择" :disabled="!editMode || system_setting.IsPurapplyTypeFixed" style="width: 100%" @change="categoryChange">
                <el-option v-for="item in PurchaseApplyCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else> 类型:{{  PurchaseApplyCategoryOptions.find(item => item.id === form.category)?.name  }}</span>
          </el-col>
             <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="deliveryTime" label="期望配送时间">
                  <el-date-picker v-model="form.deliveryTime" value-format="yyyy-MM-dd" :disabled="!editMode" type="date"   style="width: 100%">
                </el-date-picker>
              </el-form-item>
                  <span  span class="viewText" v-else> 期望配送时间:{{parseTime(new Date(form.deliveryTime), "{y}-{m}-{d}") }}</span>
             </el-col>
          <el-col :span="3" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="totalNumber" label="申请总数量">
              <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
            </el-form-item>
            <span class="viewText" v-else> 申请总数量:{{ form.totalNumber }}</span>
          </el-col>
          <el-col :span="3" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="totalAmount" label="申请总金额">
              <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
            </el-form-item>
            <span class="viewText" v-else> 申请总金额:{{ form.totalAmount }}</span>
          </el-col>
          <el-col :span="6" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" label="备注" prop="remark">
              <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
            </el-form-item>
            <span class="viewText" v-else> 备注:{{ form.remark }}</span>
          </el-col>

          <el-col :span="4" :class="!getIsView()?'viewCol':''">
            <el-form-item v-if="getIsView()" prop="totalAmount" label="配送点">
              <el-select v-model="form.distributionPointName" placeholder="请选择" :disabled="!editMode" @change="distributionPointChange" style="width: 100%">
                <el-option v-for="(item,index) in STATIC_Delivery" :key="index" :label="item" :value="index"></el-option>
              </el-select>
            </el-form-item>
            <span class="viewText" v-else> 配送点:{{ form.distributionPointName }}</span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px"></el-row>
      </div>

      <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">申请明细</span>
        </div>

        <div v-if="editMode" style="margin: 20px 0 12px 10px">
          <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
          <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
        </div>
        <div v-else style="margin-top: 20px"></div>

        <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" max-height="600" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column type="index"  width="50" fixed="left"> </el-table-column>
          <el-table-column type="selection" width="55"  align="center" fixed="left"></el-table-column>
          <el-table-column prop="productName" label="产品" width="180" fixed="left"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specName" fixed="left" label="产品规格" width="180"></el-table-column>
          <el-table-column prop="supplierProductNo" label="供应商产品编码"   width="180"></el-table-column>

          <el-table-column :show-overflow-tooltip="true" prop="productRegistCertName" :key="'productRegistCertName'" label="注册证名称" width="180"></el-table-column>
          <el-table-column prop="number" label="申请数量" width="120" :key="'number'"></el-table-column>
          <el-table-column prop="packSpec" label="包装规格" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.packSpec?scope.row.packSpec:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minUnit" label="最小单位" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.minUnit?scope.row.minUnit:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockNumber" label="科室库存" width="100"></el-table-column>
          <el-table-column prop="oneLevelStockNumber" label="目标库房库存" width="120"></el-table-column>

          <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="120"></el-table-column>
          <el-table-column prop="price" label="单价" width="120"></el-table-column>
          <el-table-column prop="amount" label="小计" width="120"></el-table-column>
          <el-table-column prop="limitNumber" label="限额可领数量" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.limitNumber?scope.row.limitNumber:'-' }}</span>
            </template>
          </el-table-column>

          <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商" width="180"></el-table-column>
          <el-table-column prop="receivedNumber" label="已领数量" width="120"></el-table-column>
          <el-table-column prop="notReceivedNumber" label="未领数量" width="120"></el-table-column>
          <el-table-column prop="planOrderNumber" label="计划采购数量" width="120">
            <template slot-scope="scope">{{
                scope.row.state == 1 || scope.row.state == 2
                  ? scope.row.planOrderNumber
                  : 0
              }}</template>
          </el-table-column>
          <el-table-column prop="actualOrderNumber" label="订单数量" width="120">
            <template slot-scope="scope">{{
                scope.row.state == 2 ? scope.row.actualOrderNumber : 0
              }}</template>
          </el-table-column>
          <!-- <el-table-column prop="brand" label="品牌" width="100"></el-table-column> -->
          <el-table-column prop="remark" label="备注" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>

          <el-table-column fixed="right" width="160" label="完成情况">
            <template slot-scope="scope">
              <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.receivedNumber, scope.row.number)" color="#42b983" />
            </template>
          </el-table-column>
          <el-table-column fixed="right" prop="stateName" label="状态" width="120"></el-table-column>
        </el-table>
      </div>

      <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
    </el-form>

    <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="supplierProductNo" label="供应商产品编码">
              <el-input disabled v-model="childForm.supplierProductNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="productName">
              <SelectTable :disabled="!editMode" :columns="applySupplierProductColumns" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_ApplySupplierProducts" @filterMethod="getProductList" @change="productChange" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="isHaveStock" label="目标库房库存>0">
              <el-checkbox :disabled="isHaveStockDisabled()" v-model="childForm.isHaveStock" @change="isHaveStockChange"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="specName" label="规格型号">
              <el-input disabled v-model="childForm.specName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item prop="productRegistCertName" label="产品注册证">
              <el-input disabled v-model="childForm.productRegistCertName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="productRegistCertNo" label="注册证号">
              <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="manufacturerName" label="生产厂家">
              <el-input disabled v-model="childForm.manufacturerName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="onlineNo" label="挂网号">
              <el-input disabled v-model="childForm.onlineNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="brand" label="品牌">
              <el-input disabled v-model="childForm.brand"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="stockNumber" label="科室库存">
              <el-input disabled v-model="childForm.stockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="oneLevelStockNumber" label="目标库房库存">
              <el-input disabled v-model="childForm.oneLevelStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="supplierName" label="供应商">
              <el-input disabled v-model="childForm.supplierName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="minUnit" label="最小单位">
              <el-input disabled v-model="childForm.minUnit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="unit" label="包装单位">
              <el-input disabled v-model="childForm.unit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="number" label="数量">
              <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
              <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="childNumberChange"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="price" label="单价">
              <el-input disabled v-model="childForm.price"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="amount" label="小计">
              <el-input disabled v-model="childForm.amount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="packSpec" label="包装规格">
              <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="limitNumber" label="限额可领数量">
              <el-input disabled v-model="childForm.limitNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="remark" label="备注">
              <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
              <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <div slot="footer" class="footer-bottom">
    <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
    <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
    <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
    <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
    <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
  </div>
</div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetPurchaseApplyById,
  SavePurchaseApply,
  RejectPurchaseApply,
  GetStockNumber,
  GetOneLevelStockNumber,
  GetSupplierProducts,
  GetDeptApplyTotalAmount,
  GetWarehousesByDeptId,
  GetWarehousesByDeptIdAndWard,
} from "@/api";
import {
  InStockOptions,
  AssetSourceOptions,
  PurchaseApplyCategoryOptions,
  OrderPressingOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data() {
    return {
      form: {},
      InStockOptions: InStockOptions,
      AssetSourceOptions: AssetSourceOptions,
      PurchaseApplyCategoryOptions: PurchaseApplyCategoryOptions,
      OrderPressingOptions: OrderPressingOptions,
      rules: {
        // warehouseName: [
        //   { required: true, message: '请选择仓库', trigger: 'blur' }
        // ],
        applyDeptName: [{
          required: true,
          message: "请选择请领科室",
          trigger: "blur"
        }],
        oneLevelWarehouseName: [{
          required: true,
          message: "请选择目标库房",
          trigger: "blur"
        }, ],
        pressingState: [{
          required: true,
          message: "请选择紧急标识",
          trigger: "blur"
        }],
      },
      childFormRules: {
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur"
        }],
        number: [{
            required: true,
            message: "数量不能为空",
            trigger: "blur"
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
          {
            validator: this.validateLimitNumber,
            trigger: "blur"
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectPurchaseApply,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // showCapitalSource: false,
      // showCapitalSourceTwo: false,
      // showCapitalSourceThree: false,
      capitalSourcemaxCount: 0,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      isCopy: false,
    };
  },

  created() {
    var query = this.$route.query;
    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDeptsBySessionDeptId("");
    }
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true;
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    // this.getWarehouses('')
    // this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate(id) {
      GetPurchaseApplyById({
        id
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.form.distributionPointName = res.returnData.distributionPoint
        this.initWorkFlowProperty(this.form);

        if (this.isCopy) {
          this.form.id = 0;
          this.form.no = "";
          this.form.status = 2;
          this.form.applyStatus = 0;
          this.form.state = 0;
          this.form.category = 0;
          this.form.workFlowInstanceId = 0;
          let now = this.parseTime(new Date());
          let user = this.userInfo;
          this.form.createdUserName = user.name;
          this.form.createdUser = user.id;
          this.form.ownerDept = user.deptId;
          this.form.ownerDeptName = user.deptName;
          this.form.createdTime = now;
          this.form.isAutoCreated = 0
          this.form.effectiveTime = null

          let supplierProductIds = this.form.details.map((e) => e.supplierProductId);

          if (this.form.details) {
            GetSupplierProducts({ids:supplierProductIds}).then(res=>{
              this.form.details.forEach(v=>{
                res.returnData.data.forEach(k=>{
                  if(v.supplierProductId == k.id){
                    v.supplierName = k.supplierName
                    v.packSpec = k.packSpec
                    v.minUnit = k.minUnit
                    v.price = k.purchasePrice
                    v.amount = (k.purchasePrice*v.number)
                    v.secondSupplierId = k.secondSupplierId
                    v.secondSupplierName = k.secondSupplierName
                  }
                })
              })
              this.autoTotalAmount()
            }).then(()=>{
              this.form.details.map((item) => {
              item.receivedNumber = 0;
              item.notReceivedNumber = item.number;
              item.state = 0;
              item.stateName = "";

              GetOneLevelStockNumber({
                  supplierProductId: item.supplierProductId,
                  stockCategory: 0,
                  warehouseId: this.form.oneLevelWarehouseId,
                })
                .then((res) => {
                  this.form.details = this.form.details.map((detail) => {
                    if (item.$index == detail.$index) {
                      detail.oneLevelStockNumber = res.returnData.stockNumber;
                    }
                    return detail;
                  });
                })
                .then(() => {
                  return GetStockNumber({
                    supplierProductId: item.supplierProductId,
                    wareHouseId: this.form.warehouseId,
                  });
                })
                .then((res) => {
                  this.form.details = this.form.details.map((detail) => {
                    if (item.$index == detail.$index) {
                      detail.stockNumber = res.returnData.stockNumber;
                    }
                    return detail;
                  });
                });

              return item;
            });
            })
        
          }
        }
      });
    },
    // 保存
    submit() {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }

        if (!this.form.details || this.form.details.length == 0) {
          this.$my_message("明细表不能为空", "warning");
          this.$store.dispatch('SetLoading',false)
          return;
        }

        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        if (!supplierProductIds || supplierProductIds.length == 0) {
          this.$my_message("存在没有供应商产品的明细表", "warning");
          this.$store.dispatch('SetLoading',false)
          return;
        }

        if (this.form.details) {
          for (var i = 0; i < this.form.details.length; i++) {
            if (
              this.form.details[i].limitNumber &&
              this.form.details[i].number > this.form.details[i].limitNumber
            ) {
              this.$my_message(`第${i + 1}行：申领数量大于申领限额数量`, "warning");
              this.$store.dispatch('SetLoading',false)
              return false;
            }
          }
        }

        GetSupplierProducts({
            ids: supplierProductIds,
            pageIndex: 1,
            pageSize: 999
          })
          .then((res) => {
       
            let msg = "";
            for (let i = 0; i < this.form.details.length; i++) {
              let sp = res.returnData.data.find(
                (e) => e.id == this.form.details[i].supplierProductId
              );
              let sp1 = res.returnData.data.find(
                (e) => e.isEnabled==0&&e.no==this.form.details[i].supplierProductNo
              );
              if(this.form.category==1&&sp1){
                msg += `第${i + 1}行：${this.form.details[i].supplierProductNo
                      } 产品名称 [${this.form.details[i].productName}] 规格型号 [${this.form.details[i].specName
                      }] <br/>`;
                msg += "已被禁用，不能下采购！";
                     break
              }
              // console.log(sp, 'sp', sp.isEnabled != 1, this.form.details[i].number, this.form.details[i].oneLevelStockNumber)
              if (
                sp &&
                sp.isEnabled != 1 &&
                this.form.details[i].number > this.form.details[i].oneLevelStockNumber
              ) {
                msg = `第${i + 1}行：产品名称 [${this.form.details[i].productName
                  }] 规格型号 [${this.form.details[i].specName
                  }]的产品<span style="color:red">已被禁用</span>，请领数量不能超出目标库房已有库存数量${this.form.details[i].oneLevelStockNumber
                  }`;
                break;
              }
            }
            if (msg) {
              this.$my_message(msg, "warning");
              this.$store.dispatch('SetLoading',false)
              throw msg;
            }
            return GetDeptApplyTotalAmount({
              deptId: this.form.ownerDept
            });
          })
          .then((res) => {
            let chargeAmount = 0;
            let notChargeAmount = 0;
            console.log(this.form.details);
            this.form.details.map((item) => {
              if (item.billingLogo == 1) {
                chargeAmount += item.amount;
              } else {
                notChargeAmount += item.amount;
              }
            });
            let errMsg = "";
            if (
              res.returnData.charge &&
              chargeAmount > 0 &&
              chargeAmount + res.returnData.chargeAmounted > res.returnData.chargeAmount
            ) {
              errMsg += "计费";
            }
            if (
              res.returnData.notCharge &&
              notChargeAmount > 0 &&
              notChargeAmount + res.returnData.notChargeAmounted >
              res.returnData.notChargeAmount
            ) {
              if (!errMsg || errMsg == "") {
                errMsg = "不计费";
              } else {
                errMsg += "和不计费";
              }
            }

            if (errMsg) {
              this.$store.dispatch('SetLoading',false)
              return this.$alert(errMsg + "产品已超过计划请领限额，请注意控制！");
            }
          })
          .then((res) => {
            return SavePurchaseApply(this.form).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
          })
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          });
      });
    },
    resetForm() {
      
      this.form = {
        inStockType: 0,
        supplierName: "",
        assetCheckNo: "",
        assetCheckId: "",
        state: 0,
        pressingState: 0,
        category: 0,
        details: [],
        applyDeptName: this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        applyDeptId: this.mySessionStorage.getDeptId(),
        wardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        warehouseId: this.mySessionStorage.getWarehouseId(),
        "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        createdTime: this.parseTime(new Date()),
        deliveryTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        ownerDept: this.userInfo.deptId,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
      // if (
      //   !this.userInfo.isAdmin &&
      //   this.userInfo.deptInfos &&
      //   this.userInfo.deptInfos.length == 1
      // ) 
  
      
      
      this.getWarehouseList('')
    },
    // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)

      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      if(this.form.applyDeptName&&this.form.oneLevelWarehouseName){
        this.openSubformModal = true;
        this.editChildren = false;
        this.resetDetailFormData();
        this.getProductList("");
      }else{
        this.$message({
          message: '请先填写请领科室和目标库房',
          type: 'warning'
        });
      }

    },
    handleDeleteChildForm() {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));

      this.getProductList("");
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        productName: "",
        productId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: 0,
        oneLevelStockNumber: 0,
        number: 0,
        price: 0,
        amount: 0,
        limitNumber: "",
        remark: "",
        isHaveStock: true,
        packSpec: "",
      };

      if (this.form.category == 1) {
        this.childForm.isHaveStock = false;
      }
    },
    cancelChildDialog() {
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.pushChildForm(true);
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList("");
    },
    pushChildForm(close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
          e.$index != this.childForm.$index &&
          e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange() {
      this.childForm.notReceivedNumber = this.childForm.number;
      this.childForm.planOrderNumber = this.childForm.number;
      this.childForm.actualOrderNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount() {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount() {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    // warehouseChange (val) {
    //   let item = this.STATIC_Warehouses.find((e) => e.id == val);
    //   if (item) {
    //     this.form.warehouseId = item.id;
    //     this.form.warehouseManagerId = item.managerId;
    //     this.form.warehouseManagerName = item.managerName;
    //   }

    //   this.getLocations(val);
    // },

    applyDeptChange1(val){
      let arr = this.STATIC_DeptAndWards.filter(res=>res.idGroup == val)
      this.form.applyDeptName =  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.applyDeptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getWarehouseList('')
      this.getProductList('')
      this.getDelivery1(arr[0].idGroup).then(res=>{
        this.form.distributionPointName = res?res[0]:''
        this.form.distributionPoint = res?res[0]:''
      })
    },
    applyDeptChange(val) {
      this.form.applyDeptId = val;
      this.getDelivery(this.form.applyDeptId).then(res=>{
            this.form.distributionPointName = res?res[0]:''
        this.form.distributionPoint = res?res[0]:''
      })
      this.getProductList('')
      this.getWarehouseList('')
    },
    oneLevelWarehouseChange(val) {
      let item = this.STATIC_OneLevelWarehouses.find((e) => e.id == val);
      if (item) {
        this.form.oneLevelWarehouseId = item.id;
        this.form.oneLevelWarehouseManagerId = item.managerId;
        this.form.oneLevelWarehouseManagerName = item.managerName;
      }
      this.form.details = [];
      this.getProductList("");
    },
    distributionPointChange(val){
     let arr = this.STATIC_Delivery.filter((e,index) => index == val);
     
     this.form.distributionPoint = arr[0]
     this.$forceUpdate()
    },
    locationChange(val) {
      let item = this.STATIC_Locations.find((e) => e.id == val);
      if (item) {
        this.childForm.locationName = item.name;
      }
    },
    isHaveStockChange() {
      this.getProductList("");
    },
    productChange(row) {
      let id = this.childForm.id;
      let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id);
      console.log(row);
      
      this.childForm = Object.assign(this.childForm, row);
      this.childForm.id = id;
      this.childForm.supplierProductId = row.id;
      this.childForm.number = 1;
      this.childForm.receivedNumber = 0;
      this.childForm.notReceivedNumber = 1;
      this.childForm.planOrderNumber = 1;
      this.childForm.actualOrderNumber = 1;
      this.childForm.price = this.childForm.purchasePrice;
      this.childForm.amount = this.childForm.price;
      this.childForm.supplierProductNo = this.childForm.no;
      this.childForm.remark = "";

      setTimeout(() => {
        this.$refs.number.focus();
        this.$refs.number.select();
      }, 1);

      this.childForm.stockNumber = 0;
      let fn = ()=>{
        GetStockNumber({
            supplierProductId: arr[0].id,
            warehouseId: this.form.warehouseId,
          }).then((res) => {
            this.childForm.stockNumber = res.returnData.stockNumber;
          });
      }
      if (this.system_setting.IsUseWard) {
       GetWarehousesByDeptIdAndWard({deptIdAndWardIdGroup:`${this.form.applyDeptId}${ this.form.wardId?'-'+this.form.wardId:''}`}).then(res=>{
        this.form.warehouseId = res.returnData.id;
       }).then(()=>{
        fn()
       })
      }else{
        GetWarehousesByDeptId({
          deptId: this.form.applyDeptId
        })
        .then((res) => {
          this.form.warehouseId = res.returnData.id;
        })
        .then(() => {
          fn()
        });
      }


      var warehouseId = this.form.oneLevelWarehouseId;
      if (!warehouseId) {
        warehouseId = "";
      }

      this.childForm.oneLevelStockNumber = 0;
      GetOneLevelStockNumber({
        supplierProductId: arr[0].id,
        stockCategory: 0,
        warehouseId: warehouseId,
      }).then((res) => {
        this.childForm.oneLevelStockNumber = res.returnData.stockNumber;
      });

      this.$refs.childForm.validateField("productName");
    },
    categoryChange(val){
       if (this.form.details && this.form.details.length > 0) {
          this.$confirm('你切换了请领单类型，是否需要清空申请明细？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.form.details = []
            this.getProductList('')
          }).catch(() => {
           
          });
        }
    },
    getProductList(keyWord) {
      if (!this.form.applyDeptId) {
        this.STATIC_ApplySupplierProducts = []
        return
      }
      let warehouseId = "";
      if (this.form.oneLevelWarehouseId) {
        warehouseId = this.form.oneLevelWarehouseId;
      }

      // let user = this.userInfo;

      // query.pageIndex = 1
      // query.pageSize = 50
      // query.deptId = user.deptId
      // query.warehouseId = warehouseId
      // query.isHaveStock = 1
      // query.status = 2
      let query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 50,
        // isEnabled: 0,
        supplierApproveStates: [2],
        deptId: this.form.applyDeptId,
        warehouseId: warehouseId,
        isHaveStock: 1,
        status: 2,
        stockCategory:0,
        applyOrPlan:1
      };
      
      // 忽略目标库房有库存，需要启用的供应商产品；目标库房有库存，可以选到禁用的供应商产品
      if (this.childForm && !this.childForm.isHaveStock) {
        
        query.isHaveStock = 0;
        query.isEnabled = 1;
      }
      
      this.getApplySupplierProducts(query);
    },
    getWarehouseList(keyWord) {
      if (this.form.applyDeptId) {
        this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.applyDeptId)
      } else {
        this.STATIC_OneLevelWarehouses = []
      }
    },
   isHaveStockDisabled(){
     if(this.editMode&&!this.system_setting.IsPurapplyTypeFixed&&this.form.category==1){
      return false
    }
    if(this.editMode&&!this.system_setting.IsPurapplyTypeFixed){
      return true
    }
    else if(this.editMode&&this.system_setting.IsPurapplyTypeFixed){
      return false
    }else if(!this.editMode&&this.system_setting.IsPurapplyTypeFixed){
      return true
    }else if(!this.editMode&&!this.system_setting.IsPurapplyTypeFixed){
      return true
    }
   }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
